<template>
  <div class v-if="atual">
    <div class="header-desktop bg-white" >
      <div class="header" :style="{backgroundImage:  'url('+atual[pagina].banner.url}">
        <div class="flex flex-wrap justify-between container topo">
          <div class="w-1/2 my-auto">
            <img
              class="my-auto responsive"
              src="@/assets/images/novaintegracao/logo-nova.svg"
              alt="logo nova"
            />
          </div>

          <div class="1/2 flex my-auto">
            <h3 class="my-auto text-dark">
              Olá
              <strong>{{user.name}}!</strong>
            </h3>
            <img class="ml-3" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>
            <h6 class="ml-2 my-auto text-white logout " @click="logout">sair</h6>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap shadow-lg">
        <div class="w-1/3  py-4 " :class="[{btninative: !atual[pagina-1] }]" @click="alterpage(pagina)">
          <div class="flex justify-center controladores items-center " v-if="atual[pagina-1]">
            <div>
              <img class src="@/assets/images/novaintegracao/arrow-left.svg" alt="logo nova"/>
            </div>

            <div class="mx-3 text-center">
              <p class="vermelhowdc font-semibold montserrat text-xs">Passo</p>
              <h3 class="font-black montserrat azulwdc text-4xl">{{pagina}}</h3>
            </div>

            <div class="roboto barra pl-4">
              <h4 class="font-light">{{atual[pagina-1].titulo}}</h4>
            </div>

          </div>
          <div class="flex justify-center controladores items-center py-4" v-else>
            <h3 class="font-black montserrat azulwdc text-4xl">Início</h3>
          </div>
        </div>

        <div class="w-1/3 py-4 text-center shadow-sm borda">
          <p class="vermelhowdc font-semibold montserrat tracking-widest">passo {{pagina+1}}</p>
          <h6 class="font-light azulwdc text-xl">
            <strong>{{atual[pagina].titulo}}</strong>
          </h6>
        </div>

        <div class="w-1/3  py-4 ">
          <div class="flex justify-center items-center border-left text-xs montserrat controladores"
               v-if="atual[pagina+1]" @click="alterpage(pagina+2)">
            <div class="roboto barra-direita pr-4 text-right">
              <h4 class="font-light">{{atual[pagina+1].titulo}}</h4>
            </div>

            <div class="mx-3 text-center">
              <p class="vermelhowdc font-semibold montserrat text-xs">Passo</p>
              <h3 class="font-black montserrat azulwdc text-4xl">{{pagina +2}}</h3>
            </div>

            <div>
              <img class src="@/assets/images/novaintegracao/arrow-right.png" alt="logo nova"/>
            </div>
          </div>
          <div class="flex justify-center items-center py-4 border-left text-xs montserrat controladores" @click="finalizar" v-else>
            <div class="mx-3 text-center">
              <h3 class="font-black montserrat azulwdc text-4xl" >Finalizar</h3>
            </div>
            <div>
              <img class src="@/assets/images/novaintegracao/arrow-right.png" alt="logo nova"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile -->
    <div class="header-mobile">
      <div class="header" >
        <div class="container topo" style=" background-position: center;  background-size: cover; " :style="{backgroundImage:  'url('+get_img_api_public(atual[pagina].banner)} ">
          <div class="my-auto">
            <div class="flex ml-auto w-100">
              <img
                class="ml-auto mt-3"
                src="@/assets/images/novaintegracao/avatar-novo.svg"
                alt="avatar"
              />
              <h6 class="ml-2 my-auto text-white cusor-pointer" @click="logout">sair</h6>
            </div>

            <div class="w-100 flex items-center">
              <img
                class="m-auto responsive"
                src="@/assets/images/novaintegracao/logo-nova.svg"
                alt="logo nova"
              />
            </div>
          </div>
        </div>
      </div>

      <!--  ===== CONTROLADORES ===== -->
      <div class="flex flex-wrap shadow-lg">
        <div class="w-1/2 flex justify-center controladores items-center py-4 bg-white" :class="[{btninative: !atual[pagina-1] }]">
          <div v-if="atual[pagina-1]">
            <img
              class="mt-1"
              style="width:15px;"
              src="@/assets/images/novaintegracao/arrow-left.svg"
            />
          </div>

          <div class="mx-3 text-center" v-if="atual[pagina-1]" @click="alterpage(pagina)">
            <h3 class="font-black montserrat azulwdc text-sm" >Anterior</h3>
          </div>
          <div class="mx-3 text-center" v-else>
            <h3 class="font-black montserrat azulwdc text-sm">Início</h3>
          </div>

        </div>

        <div class="w-1/2 flex justify-center items-center py-4 border-left text-xs montserrat controladores bg-white" v-if="atual[pagina+1]" @click="alterpage(pagina+2)">
          <div class="mx-3 text-center" >
            <h3 class="font-black montserrat azulwdc text-sm" >Próximo</h3>
          </div>

          <div>
            <img
              class="mt-1"
              style="width:15px;"
              src="@/assets/images/novaintegracao/arrow-right.png"
            />
          </div>
        </div>
        <div class="w-1/2 flex justify-center items-center py-4 border-left text-xs montserrat controladores bg-white" v-else @click="finalizar">
          <div class="mx-3 text-center" >
            <h3 class="font-black montserrat azulwdc text-sm" >Finalizar</h3>
          </div>

          <div>
            <img
              class="mt-1"
              style="width:15px;"
              src="@/assets/images/novaintegracao/arrow-right.png"
            />
          </div>
        </div>
      </div>

      <div class="py-4 text-center shadow-sm">
        <p class="vermelhowdc font-semibold montserrat tracking-widest">passo {{pagina+1}}</p>
        <h6 class="font-light azulwdc text-xl"><strong>{{atual[pagina].titulo}}</strong></h6>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
      text_color: {
        type: String,
        default: "#001C32",
      },
      atual: {
        type: Array,
      },
      pagina: {
        type: Number,
      },
      user: {
        type: Object,
      },
    },
    methods:{
      alterpage(page){
        this.$emit('mudadepagina',page);
      },
      finalizar(){
        this.$router.push({name:'integracao-avaliacaoinicio'})
      },
      logout(){
        localStorage.removeItem('integracaoLogged');
        this.$router.push({name:'novaintegracao-login'})
      }
    }
  };
</script>

<style scoped>
  .borda{
    border-right: 3px solid #EDEDED;
    border-left: 3px solid #EDEDED;
    border-bottom: 6px solid #C61517;
  }
</style>
